import { useEffect } from "react";
import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useUserConsent } from "../../../../utils/consentManagement";
const KEY = "consent";
/**
 * Ensures that the Usercentrics root element has the attribute
 * `data-react-aria-top-layer="true"` so that React Aria can
 * properly manage focus for overlays.
 * See https://github.com/adobe/react-spectrum/issues/8784#issuecomment-3415368636
 */
export const useUsercentricsAttribute = () => {
    useEffect(() => {
        const applyAttribute = () => {
            const el = document.querySelector("#usercentrics-root");
            if (el) {
                el.setAttribute("data-react-aria-top-layer", "true");
                el.removeAttribute("inert");
            }
        };
        if (window.UC_UI) {
            applyAttribute();
            return;
        }
        window.addEventListener("UC_UI_INITIALIZED", applyAttribute, {
            once: true,
        });
        return () => {
            window.removeEventListener("UC_UI_INITIALIZED", applyAttribute);
        };
    }, []);
};
export const useInitConsent = () => {
    const isUserConsent = useUserConsent();
    const { dispatch } = useOverlayOrchestrator();
    useUsercentricsAttribute();
    useEffect(() => {
        if (isUserConsent) {
            dispatch({ type: "COMPLETE", payload: KEY });
        }
    }, [dispatch, isUserConsent]);
};
